import React, { useState } from 'react';

// Wraps a password input with an eye toggle so the user can reveal what they
// typed. Deliberately only used for account passwords; transaction PIN inputs
// stay obscured so shoulder surfing cannot pick them up.
const PasswordInput = ({ id, className = 'form-control', ...inputProps }) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div className="input-group">
            <input
                {...inputProps}
                id={id}
                type={isVisible ? 'text' : 'password'}
                className={className}
            />
            <button
                type="button"
                className="btn btn-outline-secondary"
                aria-label={isVisible ? 'Hide password' : 'Show password'}
                aria-pressed={isVisible}
                onClick={() => setIsVisible((current) => !current)}
                tabIndex={-1}
            >
                <i className={isVisible ? 'fa fa-eye-slash' : 'fa fa-eye'} aria-hidden="true" />
            </button>
        </div>
    );
};

export default PasswordInput;
